<template>
  <div
    class="fixed bottom-0 left-0 right-0 top-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
    @click="closeModal"
  >
    <div
      class="w-full max-w-lg rounded-md bg-white px-4 py-8 text-center text-gray-900"
      @click.stop=""
    >
      <div class="mb-6 text-xs font-bold uppercase tracking-wider">
        Game Settings
      </div>
      <div class="grid grid-cols-2 gap-x-4 gap-y-2">
        <div class="my-auto text-right text-xs uppercase tracking-wider">
          Players
        </div>
        <div class="text-left">
          <select
            class="rounded px-2 py-1"
            name=""
            id=""
            v-model.number="players"
          >
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>
        </div>
        <div class="my-auto text-right text-xs uppercase tracking-wider">
          Grid Size
        </div>
        <div class="text-left">
          <select
            class="rounded px-2 py-1"
            name=""
            id=""
            v-model.number="gridSize"
          >
            <option value="3">3 x 3</option>
            <option value="4">4 x 4</option>
            <option value="5">5 x 5</option>
            <option value="6">6 x 6</option>
            <option value="7">7 x 7</option>
            <option value="8">8 x 8</option>
          </select>
        </div>

        <div class="my-auto text-right text-xs uppercase tracking-wider">
          Win Condition
        </div>
        <div class="text-left">
          <select
            class="rounded px-2 py-1"
            name=""
            id=""
            v-model="winCondition"
          >
            <option value="First to 3">First to 3</option>
            <option value="Highest Score">Highest Score</option>
          </select>
        </div>
      </div>

      <button class="btn btn--alt mt-6" @click="startGame">Start game</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      gridSize: '3',
      players: 2,
      winCondition: 'First to 3',
    }
  },

  methods: {
    closeModal() {
      this.$store.commit('SET_ACTIVE_MODAL', '')
    },

    startGame() {
      const gameData = {
        gridSize: this.gridSize,
        players: this.players,
        winCondition: this.winCondition,
        gameStatus: 'active',
        gameType: 'local',
      }

      this.$store.commit('SET_GAME', gameData)
      this.closeModal()

      this.$router.push('/local')
    },
  },
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/modals/LocalSettingsModal.vue